import RTBIcon from './RTBIcon';
import * as RTBIconNames from './RTBIconNames';

export { RTBIcon, RTBIconNames };
export default RTBIcon;
